import { createFileRoute, useRouter } from "@tanstack/react-router";
import { LayoutHeader } from "@/Header";
import { BottomArrow } from "@/Icon/BottomArrow";
import { Dialog } from "@/Dialog";
import { Controller } from "react-hook-form";
import useStoreSearch, {
  AssignAreaListType,
} from "^/customer/home/useStoreSearch";
import AddressSearch from "@/common/AddressSearch";
import { Loading } from "@/Loading";
import { CompanyType } from "~/services/customer/home";
import { ValidateControllerSelect } from "@/ControllerSelect";
import { SequentialAnimation } from "@/SequentialAnimation";
import { useEffect } from "react";
import { useLoadingStore } from "../../../stores/loading";
import defaultImg from "$/images/defaultImg.png";

interface SearchDetailParams {
  label?: string;
  value?: string;
}

export const Route = createFileRoute("/customer/layout/home-serach-store")({
  component: SearchStore,
  validateSearch: (search: Record<string, unknown>): SearchDetailParams => {
    return {
      label: search.label as string,
      value: search.value as string,
    };
  },
});

function SearchStore() {
  const { history } = useRouter();
  const { label, value } = Route.useSearch();
  const {
    // 기존 상태들
    assignAreaList,
    selectedArea,
    selectedSearchTypeFilter,
    categorys,

    // 업체 목록 관련
    companyList,
    isCompanyLoading,

    // 드롭다운 관련
    dropdownOpen,
    handleDropdownToggle,
    handleAreaSelection,

    // 검색 관련
    handleSearchTypeClick,

    // 지역 추가 관련
    setSearchArea,
    loading,
    handleAddArea,
    handleAddOkClick,

    // 모달 관련
    isOpenModal,
    closeModal,
    isOpenAddAreaModal,
    closeAddAreaModal,

    // 동 검색 안내 Dialog 관련
    isOpenDongDialog,
    closeDongDialog,

    // 알림 Dialog 관련
    isOpenAlertDialog,
    closeAlertDialog,
    alertMessage,

    // 폼 관련
    handleSubmit,
    control,
    bindSubmit,

    // 로딩 상태
    isLoading,
    isFetching,
  } = useStoreSearch();

  // 로딩 스토어 사용
  const { toggleLoading } = useLoadingStore();

  // React Query 로딩 상태와 로딩 스토어 연동
  useEffect(() => {
    toggleLoading(isLoading || isFetching);
  }, [isLoading, isFetching, toggleLoading]);
  console.log(assignAreaList);
  useEffect(() => {
    if (label && value) {
      handleSearchTypeClick({ label, value });
    }
  }, [label, value]);
  //상단부분
  const handleClick = (company: CompanyType) => {
    const params = new URLSearchParams({
      companySeq: company.companySeq.toString(),
    });
    if (company.masterYn) {
      params.append("masterYn", company.masterYn);
    }
    history.push(`/customer/layout/home-serach-detail?${params.toString()}`);
  };

  return (
    <>
      <LayoutHeader title={"주변 검색"} hasBackBtn hasFootPrint={false} />
      <div className="flex flex-col flex-auto bg-[#F5F5F5]">
        <div className="mx-2 mt-2">
          <div className="flex relative items-center mx-2">
            {/* 왼쪽 드롭다운 - 고정 */}
            <div
              className="flex flex-shrink-0 items-center pb-2 mr-4 border-b-2 border-gray-400 cursor-pointer select-none"
              onClick={handleDropdownToggle}
            >
              <span className="mx-2 w-full text-sm font-medium">
                {selectedArea?.region ? selectedArea?.region : "지역 선택"}
              </span>
              <BottomArrow />
            </div>
            {/* 드롭다운 메뉴 */}
            {dropdownOpen && (
              <div className="absolute top-8 z-10 w-40 bg-white rounded border shadow">
                {assignAreaList?.map((a: AssignAreaListType) => (
                  <div
                    key={a.regionSeq}
                    className={`px-3 py-2 text-sm cursor-pointer hover:bg-orange-50
                      ${a.region === selectedArea?.region ? "text-orange-500 font-bold" : ""}`}
                    onClick={() => handleAreaSelection(a)}
                  >
                    {a.region}
                  </div>
                ))}
                <div
                  key={99}
                  className={`px-3 py-2 text-sm cursor-pointer hover:bg-orange-50
                      ${selectedArea?.region === "지역추가" ? "text-orange-500 font-bold" : ""}`}
                  onClick={handleAddArea}
                >
                  지역추가
                </div>
              </div>
            )}
            {/* 오른쪽 필터 탭 버튼들 - 스크롤 가능 */}
            <div className="grid grid-cols-1 pb-2">
              <div className="flex overflow-x-auto gap-2 whitespace-nowrap">
                {categorys.map((category) => (
                  <button
                    key={category.label}
                    onClick={() => handleSearchTypeClick(category)}
                    className={`
                      px-4 py-1 rounded-full border text-sm font-semibold h-10
                      bg-white
                      ${
                        selectedSearchTypeFilter.label === category.label
                          ? "border-orange-400 text-orange-400"
                          : "border-transparent text-gray-700 border-[#d8d8d8]"
                      }
                    `}
                  >
                    {category.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <SequentialAnimation>
          <div className="flex flex-col gap-1 mx-2">
            {/* 로딩 표시 */}
            {isCompanyLoading && (
              <div className="flex justify-center items-center py-8">
                <Loading visible={true} />
              </div>
            )}

            {/* 업체 목록 */}
            {!isCompanyLoading && companyList && companyList.length > 0
              ? companyList.map((company: CompanyType) => (
                  <button
                    key={company.companySeq}
                    className="bg-white rounded-lg border border-[#e9e9e9] p-4"
                    onClick={() => handleClick(company)}
                  >
                    <div className="flex gap-3 justify-between">
                      <div className="flex-1 min-w-0 text-left">
                        <div className="text-lg font-bold">
                          {company.companyName}
                        </div>
                        <div className="mt-2 text-sm text-[#999999]">
                          {company.companyAddr}
                        </div>
                        {company.maxWeight ? (
                          <div className="mt-2 text-sm text-[#999999] break-words">
                            수용 범위 ~{company.maxWeight}kg
                          </div>
                        ) : null}
                      </div>
                      <div className="flex-shrink-0">
                        <img
                          src={company.fileUrl || defaultImg}
                          alt={company.companyName}
                          className="object-cover w-24 h-20 rounded-lg"
                        />
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-2 mt-4">
                      {company.provides &&
                      Array.isArray(company.provides) &&
                      company.provides.some((p) => p.available) ? (
                        company.provides
                          .filter((p) => p.available)
                          .map((provide, index) => (
                            <span
                              key={index}
                              className="px-3 py-1 text-[13px] text-orange-500 bg-orange-100 rounded-full"
                            >
                              {provide.name}
                            </span>
                          ))
                      ) : (
                        <span className="px-3 py-1 text-[13px] text-gray-500 bg-gray-100 rounded-full">
                          서비스 정보 없음
                        </span>
                      )}
                    </div>
                  </button>
                ))
              : !isCompanyLoading && (
                  <div className="flex justify-center items-center py-8">
                    <div className="text-center text-gray-500">
                      <p>검색된 업체가 없습니다.</p>
                      <p className="mt-1 text-sm">
                        다른 지역이나 카테고리를 선택해보세요.
                      </p>
                    </div>
                  </div>
                )}
          </div>
        </SequentialAnimation>

        {/* 동 검색 안내 Dialog */}
        <Dialog visible={isOpenDongDialog} onClose={closeDongDialog}>
          <div className="p-4 text-center">
            <div className="mb-2 text-lg font-semibold">동으로 검색하세요</div>
            <div className="mb-4 text-sm text-gray-600">
              정확한 지역 검색을 위해
            </div>
            <div className="mb-4 text-sm text-gray-600">
              동(읍/면/동) 단위로 검색해주세요.
            </div>
            <button
              className="py-2 w-full font-semibold text-white bg-orange-400 rounded-full"
              onClick={closeDongDialog}
            >
              확인
            </button>
          </div>
        </Dialog>

        {/* 지역 모달 */}
        <Dialog visible={isOpenModal} onClose={closeModal}>
          <div className="flex flex-col gap-3">
            <div className="text-lg font-semibold text-center">
              지역은 최대 3개까지 등록 가능해요
            </div>
            <div className="text-sm text-center">
              새로운 지역을 등록하기 위해서 삭제할 기존 등록 지역을 선택하여
              주세요
            </div>
          </div>
          <form>
            <div className="my-5">
              <Controller
                name="area"
                control={control}
                render={({ field }) => (
                  <ValidateControllerSelect
                    value={field.value ? field.value.split(",") : []}
                    onChange={(value) => field.onChange(value.join(","))}
                    max={1}
                    col = {1}
                    className="rounded-full"
                    options={assignAreaList.map((area: AssignAreaListType) => ({
                      label: area.region,
                      value: area.region,
                    }))}
                  />
                )}
              />
            </div>
          </form>
          <div className="flex gap-3 mt-2">
            <button
              className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
              onClick={closeModal}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={handleSubmit(bindSubmit)}
            >
              확인
            </button>
          </div>
        </Dialog>
        <Dialog visible={isOpenAddAreaModal} onClose={closeAddAreaModal}>
          <div className="flex flex-col gap-3 mb-2">
            <div className="text-lg font-semibold text-center">
              지역을 추가해주세요
            </div>
          </div>
          <AddressSearch onSelect={setSearchArea} />
          <div className="flex gap-3 mt-4">
            <button
              className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
              onClick={closeAddAreaModal}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full disabled:opacity-50"
              onClick={handleAddOkClick}
              disabled={loading}
            >
              {loading ? "저장 중..." : "확인"}
            </button>
          </div>
        </Dialog>

        {/* 알림 Dialog */}
        <Dialog visible={isOpenAlertDialog} onClose={closeAlertDialog}>
          <div className="p-4 text-center">
            <div className="mb-4 text-sm text-gray-600">{alertMessage}</div>
            <button
              className="py-2 w-full font-semibold text-white bg-orange-400 rounded-full"
              onClick={closeAlertDialog}
            >
              확인
            </button>
          </div>
        </Dialog>
      </div>
    </>
  );
}
